var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mobile-container",style:({ height: _setup.deviceHeight })},[_vm._t("header"),_c('div',{staticClass:"mobile-content"},[_vm._t("content")],2),_vm._t("floating")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }